import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import VenueImg from "../../Assets/venue-banner.jpeg";
import { TbBrandWhatsappFilled } from "react-icons/tb";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FaLocationDot } from "react-icons/fa6";

const VenueSection = () => {
  return (
    <section className="py-5" style={{ backgroundColor: "#FFF4FA" }}>
      <Container>
        <Row className="mb-4">
          <Col>
            <h2 className="text-center fw-bold">Conference Venue</h2>
          </Col>
        </Row>

        <Row className="align-items-center">
          <Col md={6} className="mb-4 mb-md-0">
            <h4 className="fw-semibold mb-3">Venue Location</h4>
            <p className="fw-bold mb-2">
              College Auditorium,
              <br />
              Apollo Speciality Hospitals, <br />
              Vanagaram, Chennai – 600095
            </p>
            <p>
              Located in Vanagaram, Chennai, the Apollo Speciality Hospitals
              Auditorium offers a modern, well-equipped space ideal for
              conferences and academic events. With advanced AV facilities and a
              comfortable setup, it ensures a professional and seamless
              experience for all attendees.
            </p>
          </Col>

          <Col md={6}>
            <Image
              src={VenueImg}
              alt="Venue"
              fluid
              rounded
              className="shadow-sm"
            />
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            sm={8}
            md={6}
            lg={4}
            xl={3}
            className="d-flex justify-content-around"
          >
            {/* WhatsApp */}
            <a
              href="https://wa.me/919994432135"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center bg-light rounded-circle p-3 shadow"
              style={{ cursor: "pointer", textDecoration: "none" }}
            >
              <i
                className="fab fa-whatsapp text-success"
                style={{ fontSize: "24px" }}
              ></i>
            </a>

            {/* Phone */}
            <a
              href="tel:+919994432135"
              className="d-flex align-items-center bg-light rounded-circle p-3 shadow"
              style={{ cursor: "pointer", textDecoration: "none" }}
            >
              <i
                className="fas fa-phone-alt text-primary"
                style={{ fontSize: "24px" }}
              ></i>
            </a>

            {/* Location */}
            <a
              href="https://maps.app.goo.gl/BcK7L2Ki4Rhetk4T6"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center bg-light rounded-circle p-3 shadow"
              style={{ cursor: "pointer", textDecoration: "none" }}
            >
              <i
                className="fas fa-map-marker-alt text-danger px-1"
                style={{ fontSize: "24px" }}
              ></i>
            </a>

            <a
              href="mailto:tnpyampicon2025@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center bg-light rounded-circle p-3 shadow"
              style={{ cursor: "pointer", textDecoration: "none" }}
            >
              <i
                className="fas fa-envelope"
                style={{ fontSize: "24px", color: "#2782a0" }}
              ></i>
            </a>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default VenueSection;
